import { Typography } from '../../../../../core/components/molecules/Typography';
import CompetenceCard from '../CompetenceCard';
import { verifyType } from '../../../utils/normalizer';
import SimpleCompetenceCard from '../SimpleCompetenceCard';
import { translateScores } from './aux';

interface iScoresHeader {
  scores: any;
  correction: number;
  isOld?: boolean;
  defaultOpen?: boolean;
}

export function ScoresHeader({ scores, correction, isOld = false, defaultOpen = false }: iScoresHeader) {
  if (correction === 2) {
    return (
      <div className="flex flex-col gap-md">
        <CompetenceCard
          score={scores.competencia_1_nota}
          competencia='Competência 1'
          description='Demonstrar domínio da modalidade escrita formal da língua portuguesa.'
          comment={scores.competencia_1_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={scores.competencia_2_nota}
          competencia='Competência 2'
          description='Compreender a proposta de redação e aplicar conceitos das várias áreas de conhecimento para desenvolver o tema, dentro dos limites estruturais .do texto dissertativo-argumentativo em prosa.'
          comment={scores.competencia_2_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={scores.competencia_3_nota}
          competencia='Competência 3'
          description='Selecionar, relacionar, organizar e interpretar informações, fatos, opiniões e argumentos em defesa de um ponto de vista.'
          comment={scores.competencia_3_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={scores.competencia_4_nota}
          competencia='Competência 4'
          description='Demonstrar conhecimento dos mecanismos linguísticos necessários para a construção da argumentação.'
          comment={scores.competencia_4_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={scores.competencia_5_nota}
          competencia='Competência 5'
          description='Elaborar proposta de intervenção para o problema abordado, respeitando os direitos humanos.'
          comment={scores.competencia_5_comentario}
          defaultOpen={defaultOpen}
        />
      </div>
    );
  }

  if (correction === 3 && !isOld) {
    return (
      <div className="flex flex-col gap-md">
        <CompetenceCard
          score={translateScores(Number(scores.competencia_1_nota), 1)}
          description='Desenvolvimento do tema, uso da coletânea e autoria'
          comment={scores.competencia_1_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={translateScores(Number(scores.competencia_2_nota), 2)}
          description='Compreensão e atendimento da proposta quanto ao gênero e tipo de texto'
          comment={scores.competencia_2_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={translateScores(Number(scores.competencia_3_nota), 1)}
          description='Recursos linguísticos (coesão e coerência) e progressão textual'
          comment={scores.competencia_3_comentario}
          defaultOpen={defaultOpen}
        />
        <CompetenceCard
          score={translateScores(Number(scores.competencia_4_nota), 2)}
          description='Convenções da escrita e adequação vocabular'
          comment={scores.competencia_4_comentario}
          defaultOpen={defaultOpen}
        />
      </div>
    )
  }

  if (correction === 3 && isOld) {
    if(verifyType(scores, correction, isOld)) {
      return (
        <div className="flex flex-col gap-md">
          <CompetenceCard
            score={scores.development_and_organization}
            description='Desenvolvimento do tema e organização do texto'
            comment={scores.development_and_organization_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.coherence_and_articulation}
            description='Coerência dos argumentos e articulação das partes do texto'
            comment={scores.coherence_and_articulation_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.grammatical_correction}
            description='Correção gramatical e adequação vocabular'
            comment={scores.grammatical_correction_comment}
            defaultOpen={defaultOpen}
          />
        </div>
      )
    } else {
      return (
        <div className="flex flex-row gap-lg">
          <SimpleCompetenceCard
            competencia='Desenvolvimento do tema e organização do texto'
            score={scores.development_and_organization}
          />
          <SimpleCompetenceCard
            competencia='Coerência dos argumentos e articulação das partes do texto'
            score={scores.coherence_and_articulation}
          />
          <SimpleCompetenceCard
            competencia='Correção gramatical e adequação vocabular'
            score={scores.grammatical_correction}
          />
        </div>
      )
    }
  }

  if (correction === 4) {
    if(verifyType(scores, correction)) {
      return (
        <div className="flex flex-col gap-md">
          <CompetenceCard
            score={scores.tema}
            description='Tema'
            comment={scores.tema_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.genero_tipo_de_texto_e_coerencia}
            description='Gênero/Tipo de texto e coerência'
            comment={scores.genero_tipo_de_texto_e_coerencia_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.elementos_linguisticos}
            description='Elementos linguisticos'
            comment={scores.elementos_linguisticos_comment}
            defaultOpen={defaultOpen}
          />
          {scores.coesao && ( 
            <CompetenceCard
              score={scores.coesao}
              description='Coesão'
              comment={scores.coesao_comment}
              defaultOpen={defaultOpen}
            />
          )}
        </div>
      )
    } else {
      return (
        <div className="flex flex-row gap-lg">
          <SimpleCompetenceCard competencia='Tema' score={scores.tema} />
          <SimpleCompetenceCard
            competencia='Gênero/Tipo de texto e coerência'
            score={scores.genero_tipo_de_texto_e_coerencia}
          />
          <SimpleCompetenceCard
            competencia='Elementos linguisticos'
            score={scores.elementos_linguisticos}
          />
          {scores.coesao && (
            <SimpleCompetenceCard
              competencia='Coesão'
            score={scores.coesao}
            />
          )}
        </div>
      );
    }
  }

  if (correction === 5) {
    if(verifyType(scores, correction)) {
      return (
        <div className="flex flex-col gap-md">
          <CompetenceCard
            score={scores.proposta_tematica}
            description='Proposta tematica'
            comment={scores.proposta_tematica_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.genero}
            description='Gênero'
            comment={scores.genero_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.leitura_dos_textos}
            description='Leitura dos textos'
            comment={scores.leitura_dos_textos_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.convencoes_da_escrita_e_coesao}
            description='Convenções da escrita e coesão'
            comment={scores.convencoes_da_escrita_e_coesao_comment}
            defaultOpen={defaultOpen}
          />
        </div>
      )
    } else {
      return (
        <div className="flex flex-row gap-lg">
          <SimpleCompetenceCard
            competencia='Proposta tematica'
            score={scores.proposta_tematica}
          />
          <SimpleCompetenceCard competencia='Gênero' score={scores.genero} />
          <SimpleCompetenceCard
            competencia='Leitura dos textos'
            score={scores.leitura_dos_textos}
          />
          <SimpleCompetenceCard
            competencia='Convenções da escrita e coesão'
            score={scores.convencoes_da_escrita_e_coesao}
          />
        </div>
      );
    }
  }

  if (correction === 6) {
    if(verifyType(scores, correction)){
      return (
        <div className="flex flex-col gap-md">
          <CompetenceCard
            score={scores.adequacao_a_proposta_e_genero}
            description='Adequação a proposta e genêro'
            comment={scores.adequacao_a_proposta_e_genero_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.desenvolvimento_da_proposta}
            description='Desenvolvimento da proposta'
            comment={scores.desenvolvimento_da_proposta_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.linguagem}
            description='Linguagem'
            comment={scores.linguagem_comment}
            defaultOpen={defaultOpen}
          />
        </div>
      )
    } else {
      return (
        <div className="flex flex-row gap-lg">
          <SimpleCompetenceCard
            competencia='Adequação a proposta e genêro'
            score={scores.adequacao_a_proposta_e_genero}
          />
          <SimpleCompetenceCard
            competencia='Desenvolvimento da proposta'
            score={scores.desenvolvimento_da_proposta}
          />
          <SimpleCompetenceCard
            competencia='Linguagem'
            score={scores.linguagem}
          />
        </div>
      );
    }
    
  }

  if (correction === 7) {
    if(verifyType(scores, correction)) {
      return (
        <div className="flex flex-col gap-md">
          <CompetenceCard
            score={scores.adequacao_proposta}
            description='Adequação à proposta (tema e gênero)'
            comment={scores.adequacao_proposta_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.escrita_padrao}
            description='Emprego da modalidade escrita padrão'
            comment={scores.escrita_padrao_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.coerencia_e_coesao}
            description='Coerência e coesão'
            comment={scores.coerencia_e_coesao_comment}
            defaultOpen={defaultOpen}
          />
          <CompetenceCard
            score={scores.informatividade_e_argumentacao_ou_narrativa}
            description='Nível de informatividade e de argumentação ou narratividade'
            comment={scores.informatividade_e_argumentacao_ou_narrativa}
            defaultOpen={defaultOpen}
          />
        </div>
      )
    } else {
      return (
        <div className="flex flex-row gap-lg">
          <SimpleCompetenceCard
            competencia='Adequação à proposta (tema e gênero)'
            score={scores.adequacao_proposta}
          />
          <SimpleCompetenceCard
            competencia='Emprego da modalidade escrita padrão'
            score={scores.escrita_padrao}
          />
          <SimpleCompetenceCard
            competencia='Coerência e coesão'
            score={scores.coerencia_e_coesao}
          />
          <SimpleCompetenceCard
            competencia='Nível de informatividade e de argumentação ou narratividade'
            score={scores.informatividade_e_argumentacao_ou_narrativa}
          />
        </div>
      );
    }
  }

  return <Typography> Não existem notas </Typography>;
}
